global.SPScript = require("spscript");
global.natp = {};
global.natp.components = require("../src/scripts/components");
global.natp.utils = require('../src/scripts/shared/utils');
global.natp.modals = require('../src/scripts/modals');
global.natp.jsom = require("../src/scripts/jsom")

global.natp.onload = require("../src/scripts/onload");


// WEBPACK FOOTER //
// ./entries/entry.site.js